import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import { ReactComponent as ChevronSvg } from '../../assets/icons/chevron.svg';

export const Wrapper = styled.div<{ $isOpen?: boolean; $isStatic?: boolean; $isChild?: boolean }>`
    border-top: 1px solid rgba(255, 255, 255, 0.05);
    background-color: transparent;
    position: relative;

    cursor: pointer;

    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;

    height: 68px;
    padding: 0 20px;

    color: rgba(255, 255, 255, 0.5);
    user-select: none;

    transition: color 200ms ease;

    &:hover {
        color: #fff;
    }

    ${({ $isOpen }) =>
        $isOpen &&
        css`
            color: #fff;
        `}

    ${({ $isStatic }) =>
        $isStatic &&
        css`
            border: none;
            cursor: default;
        `}

    ${({ $isChild }) =>
        $isChild &&
        css`
            padding-left: 30px;
        `}
`;

export const TextWrapper = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const Text = styled.div`
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: -0.4px;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const Chevron = styled(ChevronSvg)<{ $direction?: 'up' | 'down' | 'left' | 'right'; $noTransition?: boolean }>`
    transition: transform 0.2s ease-in-out;
    flex-shrink: 0;

    ${({ $noTransition }) =>
        $noTransition &&
        css`
            transition: none;
        `}

    ${({ $direction = 'down' }) => {
        switch ($direction) {
            case 'up':
                return css`
                    transform: scaleY(1);
                `;
            case 'down':
                return css`
                    transform: scaleY(-1);
                `;
            case 'left':
                return css`
                    transform: scaleX(1) rotate(90deg);
                `;
            case 'right':
                return css`
                    transform: scaleX(-1) rotate(90deg);
                `;
        }
    }}
`;

export const InlineButton = styled.button`
    border: none;
    cursor: pointer;

    font-weight: 700;
    font-size: 10px;
    line-height: 100%;
    text-align: center;
    letter-spacing: -0.02em;
    color: #ffffff;

    background: rgba(255, 255, 255, 0.05);
    border-radius: 40px;

    height: 24px;
    padding: 0 10px;

    display: flex;
    align-items: center;
    justify-content: center;

    transition:
        color 0.1s ease-in-out,
        box-shadow 0.1s ease-in-out,
        transform 0.1s ease-in-out;

    &:hover {
        color: #fff;
        box-shadow:
            0 0 68px 0 rgb(255 255 255 / 5%) inset,
            0 0 0 1px rgb(255 255 255 / 5%) inset;
    }

    &:active {
        color: #fff;
    }
`;

export const ActionButtonHolder = styled(motion.div)`
    white-space: nowrap;
`;
